import React from "react";
import { PCT } from "../formato";

// 10 cores (25/10/2026): com Comandas (24/10) os módulos de venda passaram de
// 7 — o 8º (iFood) repetia a cor do 2º (Mesa QR) na rosca e na tabela.
export const CORES = Array.from({ length: 10 }, (_, i) => `var(--vg-c${i + 1})`);
const CORES_AV = ["#F2B300", "#5B8DEF", "#2FC37C", "#A86BEF", "#F26D6D", "#4FC3D9", "#F2A33A", "#8290AC", "#E36BB0", "#7CD17C"];

export const iniciais = (n) => {
  const p = String(n || "?").trim().split(/\s+/);
  return (p[0][0] + (p.length > 1 ? p[p.length - 1][0] : "")).toUpperCase();
};

export function Avatar({ nome, k }) {
  return <span className="vg-av" style={{ background: CORES_AV[k % CORES_AV.length] }}>{iniciais(nome)}</span>;
}

/**
 * Rosca com destaque cruzado: `ativo` (índice) vem de fora para que passar o
 * mouse na fatia OU na linha da tabela destaque os dois.
 */
export function Donut({ itens, ativo, onAtivo, rotulo, valorCentro, fmt }) {
  const total = itens.reduce((a, i) => a + i.v, 0) || 1;
  const R = 84, r = 56, cx = 100, cy = 100, gap = 0.012;
  let a0 = -Math.PI / 2;
  const p = (ang, rad) => [cx + rad * Math.cos(ang), cy + rad * Math.sin(ang)];
  const fatias = itens.map((it, k) => {
    const frac = it.v / total, a1 = a0 + frac * Math.PI * 2, big = frac > 0.5 ? 1 : 0;
    const g = itens.length > 1 ? gap : 0;
    const [x0, y0] = p(a0 + g, R), [x1, y1] = p(a1 - g, R), [x2, y2] = p(a1 - g, r), [x3, y3] = p(a0 + g, r);
    // Uma fatia só (100%) não fecha com arco: desenha anel inteiro.
    const d = itens.length === 1
      ? `M${cx} ${cy - R} A${R} ${R} 0 1 1 ${cx - 0.01} ${cy - R} L${cx - 0.01} ${cy - r} A${r} ${r} 0 1 0 ${cx} ${cy - r} Z`
      : `M${x0} ${y0} A${R} ${R} 0 ${big} 1 ${x1} ${y1} L${x2} ${y2} A${r} ${r} 0 ${big} 0 ${x3} ${y3} Z`;
    a0 = a1;
    return (
      <path key={k} className={`slice ${ativo === k ? "on" : ""}`} d={d} fill={it.c}
        onMouseEnter={() => onAtivo(k)} onMouseLeave={() => onAtivo(null)}>
        <title>{`${it.n}: ${fmt(it.v)} (${PCT(frac * 100)})`}</title>
      </path>
    );
  });
  const centro = ativo != null && itens[ativo] ? [itens[ativo].n, PCT((itens[ativo].v / total) * 100)] : [rotulo, valorCentro];
  return (
    <div className={`vg-donut ${ativo != null ? "hl" : ""}`}>
      <svg viewBox="0 0 200 200" role="img" aria-label={rotulo}>
        {fatias}
        <text x="100" y="94" textAnchor="middle" className="center">{centro[0]}</text>
        <text x="100" y="114" textAnchor="middle" className="center-v">{centro[1]}</text>
      </svg>
    </div>
  );
}

/** Barras horizontais em ranking (entregadores, categorias). */
export function Ranking({ itens, fmt, total, avatar = false, segundo = null, classe = "" }) {
  const max = Math.max(1, ...itens.filter((i) => !i.rest).map((i) => i.v));
  const soma = total ?? itens.reduce((a, i) => a + i.v, 0);
  return (
    <div className={`vg-ranking ${classe}`}>
      {itens.map((it, k) => (
        <div key={it.n + k} className={it.rest ? "rest" : ""}>
          <span className="i">{it.rest ? "" : k + 1}</span>
          <span className="nm">
            {avatar && !it.rest && <Avatar nome={it.n} k={k} />}
            <span>{it.n}{it.s && <small>{it.s}</small>}</span>
          </span>
          <div className={`track ${k % 2 ? "alt" : ""}`}><i style={{ width: `${Math.min(100, Math.max(1.5, (it.v / max) * 100))}%` }} /></div>
          <span className="vl"><b>{fmt(it.v)}</b><small>{PCT(soma ? (it.v / soma) * 100 : 0)}{it.q ? ` · ${it.q}` : ""}</small></span>
          {segundo && <span className="vl"><b>{segundo(it)}</b></span>}
        </div>
      ))}
    </div>
  );
}
